import React, { useState } from "react";
import {
  Button,
  Flex,
  Img,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Box,
} from "@chakra-ui/react";

const AboutModal = ({ isOpen, onClose, updateAboutData, about }) => {
  const [aboutData, setAboutData] = useState();
  const containerBgColor = useColorModeValue("#fff", "#081b2e");
  const inputBgColor = useColorModeValue("#F9FAFC", "#020b19");

  const inputStyles = {
    p: "20px",
    borderRadius: "10px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    w: "100%",
    color: "#697C94",
    h: "20em",
  };

  const btnStyle = {
    p: "5px 10px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
    w: "30%",
  };

  const handleAboutData = () => {
    updateAboutData(aboutData);
    onClose();
  };

  return (
    <>
      <Modal id="groupModal" isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent bg={containerBgColor}>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
              <Heading fontSize={"1.5em"}>About</Heading>
            </Flex>

            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
              <Textarea
                {...inputStyles}
                value={aboutData}
                onChange={(e) => setAboutData(e.target.value)}
              ></Textarea>
            </Flex>

            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
              <Button bg="#07900C" {...btnStyle} onClick={handleAboutData}>
                Submit
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AboutModal;
